var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"query-response"},[(!_vm.response)?_c('div',{staticClass:"no-answer"},[_c('span',[_vm._v("\n            Not Answered\n        ")])]):_vm._e(),_vm._l((_vm.response),function(resp,index){return _c('div',{key:index,staticClass:"choice answer"},[_vm._v("\n            "+_vm._s(resp.value)+"\n    ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }